export default __webpack_public_path__ + "static/media/the lean startup.e9013d0a.jpg";